import angular from 'angular';
import { routing } from './wip.config';
import wipComponent from './wip.component';
export default angular.module('app.demo', [])
    .config(routing)
    .component('wipComponent', wipComponent)
    .name;
